import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../Routes/routes';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../style/homepage.css';

export const Logo: React.FC = () => (
  <span className="logoWrap">
    <img src="/LogoContainer.png" alt="ToothZap logo" className="logoImg" />
  </span>
);

export const Nav: React.FC = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const navRoutes: Record<string, string | null> = {
    'For Dentists': ROUTES.Fordentist,
    'For Labs': ROUTES.Forlabs,
    // 'How It Works': null,
    'Find a Dentist': ROUTES.Findadendtist,
  };

  return (
    <nav className="tz-navbar navbar navbar-expand-lg">
      <div className="container tz-container">

        {/* Logo */}
        <a className="navbar-brand p-0" href="/">
          <Logo />
        </a>

        {/* Toggle button (ONLY MOBILE) */}
        <button
          className="navbar-toggler border-0 shadow-none d-lg-none"
          type="button"
          onClick={() => setOpen(!open)}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>

     {/* NAV MENU (mobile only) */}
<div className={`collapse navbar-collapse ${open ? 'show' : ''}`}>

  {/* LINKS (mobile only) */}
  <ul className="navbar-nav mx-auto mb-2 mb-lg-0 gap-lg-4 d-lg-none">
    {Object.keys(navRoutes).map((label) => (
      <li className="nav-item" key={label}>
        <span
          className="nav-link tz-nav-link"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            const route = navRoutes[label];
            setOpen(false);
            if (route) navigate(route);
          }}
        >
          {label}
        </span>
      </li>
    ))}
  </ul>

  {/* BUTTONS (mobile only) */}
  <div className="d-flex flex-column gap-2 mt-3 d-lg-none">
    <button
      onClick={() => {
        setOpen(false);
        navigate(ROUTES.REGISTER);
      }}
      className="btn btn-sm tz-btn-primary"
    >
      Book a Demo
    </button>

    <button
      onClick={() => {
        setOpen(false);
        navigate(ROUTES.LOGIN);
      }}
      className="btn btn-sm tz-btn-text w-100"
    >
      Login
    </button>
  </div>

</div>
      </div>
    </nav>
  );
};